export default __webpack_public_path__ + "static/media/dispatched_hover_cached_selected.b763af59.svg";